import { ClaimDocumentDTO } from '@reposit/api-client';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import {
  DocumentIdCell,
  DocumentTable,
  documentTypeLabel,
  EvidenceWorkspaceDocumentLink,
  useCanOpenEvidenceWorkspace,
} from '../EvidenceWorkspaceDocumentLink';
import RepositCard from '../Reposit/RepositCard';
import { Tbody, Td, Thead, Tr } from '../Table';
import { A } from '../Typography';

interface ClaimDocumentsProps {
  documents: ClaimDocumentDTO[];
}

const SupportingDocumentsTable = styled(DocumentTable)`
  table-layout: fixed;

  && td {
    overflow-wrap: anywhere;
    padding-left: 1.6%;
    padding-right: 1.6%;
  }

  && td:first-child {
    padding-left: 4%;
  }

  && td:last-child {
    padding-right: 2%;
  }
`;

const Filename = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  overflow-wrap: anywhere;
`;

const ClaimDocuments: React.FC<ClaimDocumentsProps> = ({ documents }) => {
  const showEvidenceWorkspace = useCanOpenEvidenceWorkspace();

  return (
    <RepositCard flush title="Supporting Documents" tooltip="lorem">
      <SupportingDocumentsTable>
        <colgroup>
          <col style={{ width: '20%' }} />
          <col style={{ width: showEvidenceWorkspace ? '28%' : '42%' }} />
          <col style={{ width: '14%' }} />
          <col style={{ width: '14%' }} />
          <col style={{ width: '10%' }} />
          {showEvidenceWorkspace ? <col style={{ width: '14%' }} /> : null}
        </colgroup>
        <Thead>
          <Tr>
            <Td>ID</Td>
            <Td>Name</Td>
            <Td>Type</Td>
            <Td>Uploaded At</Td>
            <Td>Action</Td>
            {showEvidenceWorkspace ? <Td>Evidence workspace</Td> : null}
          </Tr>
        </Thead>
        <Tbody>
          {documents &&
            documents.map(({ document }) => (
              <Tr key={document.id}>
                <DocumentIdCell>{document.id}</DocumentIdCell>
                <Td>
                  <Filename title={document.name}>{document.name}</Filename>
                </Td>
                <Td>{documentTypeLabel(document.typeId)}</Td>
                <Td>{moment(document.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Td>
                <Td>
                  <A target="_blank" href={document.url}>
                    View
                  </A>
                </Td>
                {showEvidenceWorkspace ? (
                  <Td>
                    <EvidenceWorkspaceDocumentLink documentId={document.id} documentName={document.name} />
                  </Td>
                ) : null}
              </Tr>
            ))}
        </Tbody>
      </SupportingDocumentsTable>
    </RepositCard>
  );
};

export default ClaimDocuments;
